import { useApp } from "contexts/BookingContext";
import BookingCard from "./BookingCard";
import Modal from "./ModalExample";
import { useState } from "react";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./create-page";
import EditSesion from "./edit-session";
import { IconEdit, IconPlus } from "@tabler/icons-react";
import CardClickPage from "./card-click";
import { motion } from "framer-motion"; // Import animasi dari framer-motion
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react"; // Import ikon dari Tabler

const IconComponent = ({ children, value }) => {
  return (
    <span className="text-center text-muted">
      {children}
      {value}
    </span>
  );
};

const SessionBlock = ({ session }) => {
  const [isModalOpen, setIsModalOpen] = useState(false); // Mengelola status modal
  const [selectedBooking, setSelectedBooking] = useState(null); // Data booking yang dipilih
  const { handleSuccess, handleError, showCanvasHandler } = useCanvasHandler();

  // Fungsi untuk membuka modal dengan data booking
  const handleCardClick = (booking) => {
    setSelectedBooking(booking);
    // setIsModalOpen(true); // Menampilkan modal
    showCanvasHandler(
      "Reservation/Booking #" + booking.id,
      <CardClickPage onSuccess={handleSuccess} onError={handleError} />
    );
    console.log(booking);
  };

  // Fungsi untuk menutup modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // acordion
  const [openIndex, setOpenIndex] = useState(null); // State untuk akordion

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Buka/tutup akordion
  };

  return (
    <div className="row mb-3 d-flex rounded-lg text-white border bg-gray">
      {/* sisi kiri */}
      <div className="col-12 col-md-2 bg-white p-3 rounded">
        <h3 className="h5 text-dark">{session.title}</h3>
        <p className="text-muted">{session.time}</p>
        <div className="d-flex gap-3 mt-3 align-items-center">
          <span title="Capacity">
            <IconComponent value={session.stocks.stocks}>
              {/* capacity */}
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                height="1em"
                width="1em"
                className="icon me-1 text-success"
              >
                <path d="M20 11c-.2 0-.4 0-.5.1L17.4 9H20V6l-3.7 1.9L13.4 5H9v2h3.6l2 2H11l-4 2-2-2H0v2h4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4l2 2h3l3.5-6.1 1 1c-.9.7-1.5 1.9-1.5 3.1 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4M4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m16 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
              </svg>
            </IconComponent>
          </span>

          <span title="Stocks">
            <IconComponent value={session.stocks.booking}>
              {/* calendar */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="icon me-1 text-success"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                />
              </svg>
            </IconComponent>
          </span>
          <span title="Location">
            <IconComponent value={session.stocks.arrived}>
              {/* check */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="icon me-1 text-success"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
            </IconComponent>
          </span>
          <span title="Agent">
            <IconComponent value={session.stocks.in_track}>
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                height="1em"
                width="1em"
                className="icon me-1 text-success"
                // title="In Track"
                // pointerEvents={"none"}
              >
                <path d="M20 11c-.2 0-.4 0-.5.1L17.4 9H20V6l-3.7 1.9L13.4 5H9v2h3.6l2 2H11l-4 2-2-2H0v2h4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4l2 2h3l3.5-6.1 1 1c-.9.7-1.5 1.9-1.5 3.1 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4M4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m16 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
              </svg>
            </IconComponent>
          </span>
        </div>
        {/* tambahkan 2 btn yaitu edit sesi dan create booking */}
        <div className="d-flex flex-column mt-3">
          <button
            className="btn btn-warning w-100"
            title="Edit Session"
            onClick={() => {
              showCanvasHandler(
                "Edit Session",
                <EditSesion onSuccess={handleSuccess} onError={handleError} />
              );
            }}
          >
            <IconEdit size={18} className="me-2" />
            Edit
          </button>
          <button
            className="btn btn-primary w-100 mt-2"
            onClick={() => {
              showCanvasHandler(
                "Create Reservation",
                <CreatePage onSuccess={handleSuccess} onError={handleError} />
              );
            }}
          >
            <IconPlus size={18} className="me-2" />
            Booking
          </button>
        </div>
      </div>

      {/* sisi kanan */}
      {/* <div className="col-12 col-md-10 bg-white p-3 rounded">
        <div className="d-flex flex-wrap ">
          {session.bookings.map((booking, bookingIndex) => (
            <div
              key={bookingIndex}
              style={{
                flex: "0 0 calc(20% - 10px)", // 20% lebar dengan jarak antar kolom
                marginBottom: "10px",
                marginLeft: "10px",
              }}
            >
              <BookingCard
                booking={booking}
                session={session}
                onClick={handleCardClick}
              />
            </div>
          ))}
        </div>
      </div> */}
      {/* sisi kanan */}
      <div className="col-12 col-md-10 bg-white p-3 rounded">
        <div className="d-flex flex-wrap">
          {/* Tampilkan 5 card pertama */}
          {session.bookings.slice(0, 5).map((booking, bookingIndex) => (
            <div
              key={bookingIndex}
              style={{
                flex: "0 0 calc(20% - 10px)", // 20% lebar dengan jarak antar kolom
                marginBottom: "10px",
                marginLeft: "10px",
              }}
            >
              <BookingCard
                booking={booking}
                session={session}
                onClick={handleCardClick}
              />
            </div>
          ))}
        </div>

        {/* Akordion untuk kartu yang tersisa */}
        {session.bookings.length > 5 && (
          <div className="mt-3">
            <div
              onClick={() => toggleAccordion("extra")}
              className="p-2 bg-info-lt text-dark rounded d-flex justify-content-between align-items-center"
              style={{ cursor: "pointer" }}
            >
              <span>
                {openIndex === "extra"
                  ? "Hide"
                  : `Show ${session.bookings.length - 5} More Bookings`}
              </span>
              <span>
                {openIndex === "extra" ? (
                  <IconChevronUp size={18} />
                ) : (
                  <IconChevronDown size={18} />
                )}
              </span>
            </div>

            {/* Konten Akordion */}
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                openIndex === "extra"
                  ? { height: "auto", opacity: 1 }
                  : { height: 0, opacity: 0 }
              }
              transition={{ duration: 0.5 }}
              className="overflow-hidden"
            >
              <div className="d-flex flex-wrap mt-2">
                {session.bookings.slice(5).map((booking, bookingIndex) => (
                  <div
                    key={bookingIndex + 5} // Tambahkan offset untuk key
                    style={{
                      flex: "0 0 calc(20% - 10px)", // 20% lebar dengan jarak antar kolom
                      marginBottom: "10px",
                      marginLeft: "10px",
                    }}
                  >
                    <BookingCard
                      booking={booking}
                      session={session}
                      onClick={handleCardClick}
                    />
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        )}
        {session.bookings.length === 0 && (
          <p className="text-muted">No bookings in this Trip</p>
        )}
      </div>

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        selectedSession={session}
        bookingData={selectedBooking} // Kirim data booking yang dipilih ke modal
      />
    </div>
  );
};

export default SessionBlock;
